"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListKit = exports.CommonListKitFactory = exports.CodeSnippetsKit = exports.TableKit = exports.TextColorStylingKit = exports.CommonKit = exports.CommonKitFactory = void 0;
const tiptapExtensions_1 = require("../tiptapExtensions");
const kit_1 = require("../kit");
const colors_1 = require("../marks/colors");
const inlineComment_1 = require("../marks/inlineComment");
const nodes_1 = require("../nodes");
const code_1 = require("../marks/code");
const mermaid_1 = require("../nodes/mermaid");
const CommonKitFactory = (e) => ({
    text: e(tiptapExtensions_1.Text),
    document: e(tiptapExtensions_1.Document),
    paragraph: e(tiptapExtensions_1.Paragraph),
    bold: e(tiptapExtensions_1.Bold),
    italic: e(tiptapExtensions_1.Italic),
    strike: e(tiptapExtensions_1.Strike),
    comment: e(nodes_1.CommentNode),
    markdown: e(nodes_1.MarkdownNode, { HTMLAttributes: { class: 'proseCodeBlock' } }),
    inlineComment: e(inlineComment_1.InlineCommentMark),
    horizontalRule: e(tiptapExtensions_1.HorizontalRule),
    heading: e(tiptapExtensions_1.Heading),
    underline: e(tiptapExtensions_1.Underline),
    blockquote: e(tiptapExtensions_1.Blockquote, { HTMLAttributes: { class: 'proseBlockQuote' } }),
    link: e(tiptapExtensions_1.Link.extend({ inclusive: false }), {
        openOnClick: false,
        HTMLAttributes: { class: 'cursor-pointer', rel: 'noopener noreferrer', target: '_blank' }
    }),
    textAlign: e(tiptapExtensions_1.TextAlign, {
        types: ['heading', 'paragraph'],
        alignments: ['left', 'center', 'right'],
        defaultAlignment: null
    }),
    typography: e(tiptapExtensions_1.Typography),
    dropcursor: e(tiptapExtensions_1.Dropcursor),
    gapcursor: e(tiptapExtensions_1.Gapcursor),
    history: e(tiptapExtensions_1.History)
});
exports.CommonKitFactory = CommonKitFactory;
exports.CommonKit = (0, kit_1.extensionKit)('common-kit', exports.CommonKitFactory);
exports.TextColorStylingKit = (0, kit_1.extensionKit)('text-color-styling', (e) => ({
    textStyle: e(tiptapExtensions_1.TextStyle),
    testColor: e(colors_1.TextColor),
    backgroundColor: e(colors_1.BackgroundColor, { types: ['tableCell'] })
}));
exports.TableKit = (0, kit_1.extensionKit)('table-kit', (e) => ({
    table: e(tiptapExtensions_1.Table, { resizable: false, HTMLAttributes: { class: 'proseTable' } }),
    tableRow: e(tiptapExtensions_1.TableRow),
    tableHeader: e(tiptapExtensions_1.TableHeader),
    tableCell: e(tiptapExtensions_1.TableCell)
}));
exports.CodeSnippetsKit = (0, kit_1.extensionKit)('code-snippet-kit', (e) => ({
    codeBlock: e(nodes_1.CodeBlockExtension, nodes_1.codeBlockOptions),
    codeBlockMermaid: e(mermaid_1.MermaidExtension, mermaid_1.mermaidOptions),
    codeInline: e(code_1.CodeExtension, code_1.codeOptions)
}));
const CommonListKitFactory = (e) => ({
    listItem: e(tiptapExtensions_1.ListItem.extend({ group: 'listItems' })),
    bulletList: e(tiptapExtensions_1.BulletList.extend({ content: 'listItems+' })),
    orderedList: e(tiptapExtensions_1.OrderedList.extend({ content: 'listItems+' }))
});
exports.CommonListKitFactory = CommonListKitFactory;
exports.ListKit = (0, kit_1.extensionKit)('list-kit', (e) => ({
    ...(0, exports.CommonListKitFactory)(e),
    todoItem: e(nodes_1.TodoItemNode),
    todoList: e(nodes_1.TodoListNode)
}));
//# sourceMappingURL=common-kit.js.map